import { Button } from 'reactstrap'

type Props = {
  total: number
  offset: number
  max: number
  onPageChange: (offset: number) => void
}

const CertPager = ({ total, offset, max, onPageChange }: Props) => {
  const totalPages = Math.ceil(total / max)
  const currentPage = totalPages === 0 ? 0 : Math.ceil((offset + 1) / max)

  if (totalPages <= 1) return null

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange((page - 1) * max)
    }
  }

  return (
    <nav
      aria-label="Pagination"
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        alignItems: 'center'
      }}
    >
      <div role="group" aria-label="Previous pages">
        <Button
          color="primary"
          className="mr-1"
          disabled={currentPage <= 1}
          onClick={() => goToPage(1)}
        >
          <span className="cert-pager-icon glyphicons glyphicons-fast-backward" />
          &nbsp;First
        </Button>
        <Button
          color="primary"
          disabled={currentPage <= 1}
          onClick={() => goToPage(currentPage - 1)}
        >
          <span className="cert-pager-icon glyphicons glyphicons-rewind" />&nbsp;Prev
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        Page
        <input
          style={{ width: '4ch', margin: '0 0.25rem' }}
          className="input-sm"
          defaultValue={currentPage}
          key={currentPage}
          onBlur={(e) => goToPage(parseInt(e.target.value, 10))}
        />
        of {totalPages}
      </div>
      <div role="group" aria-label="Next pages">
        <Button
          color="primary"
          className="mr-1"
          disabled={currentPage >= totalPages}
          onClick={() => goToPage(currentPage + 1)}
        >
          Next&nbsp;
          <span className="cert-pager-icon glyphicons glyphicons-forward" />
        </Button>
        <Button
          color="primary"
          disabled={currentPage >= totalPages}
          onClick={() => goToPage(totalPages)}
        >
          Last&nbsp;
          <span className="cert-pager-icon glyphicons glyphicons-fast-forward" />
        </Button>
      </div>
    </nav>
  )
}

export default CertPager
